export default "__VITE_ASSET__DHGbmrPW__"